export const chaptersList = [
	{ divider: true, value: "Account" },
	{ header: "Account", value: "Account" },
	{ text: "Account users", value: "Account users" },
	{ text: "Account St-ts", value: "Account St-ts" },
	{ text: "Comments", value: "Comments" },
	{ text: "My Info", value: "My Info" },
	{ text: "Salary History", value: "Salary History" },
	{ text: "Vacation", value: "Vacation" },
	{ text: "Bonus/Charge", value: "Bonus/Charge" },
	{ text: "Events", value: "Events" },
	{ text: "Geo", value: "Geo" },
	{ divider: true, value: "Account users" },
	{ header: "Account users", value: "Account users" },
	{ text: "My Info", value: "My Info" },
	{ text: "Account St-ts", value: "Account St-ts" },
	{ text: "Account Comments", value: "Account Comments" },
	{ text: "Account Salary History", value: "Account Salary History" },
	{ text: "Account Vacation", value: "Account Vacation" },
	{ text: "Account Geo", value: "Account Geo" },
	{ text: "Account Bonus/Charge", value: "Account Bonus/Charge" },
	{ text: "", value: "" },
	{ text: "", value: "" },
	{ text: "", value: "" },
	{ text: "", value: "" },
	{ text: "", value: "" },

	{ text: "Profile", value: "Profile" },

	{ divider: true, value: "Dispatch" },
	{ header: "Dispatch", value: "Dispatch" },
	{ text: "Dashboard", value: "Dashboard" },
	{ text: "Trips", value: "Trips" },

	{ divider: true, value: "Safety" },
	{ header: "Safety", value: "Safety" },
	{ text: "Logbooks", value: "Logbooks" },

	{ divider: true, value: "Statistics" },
	{ header: "Statistics", value: "Statistics" },
	{ text: "Customer not paid invoices", value: "Customer not paid invoices" },
	{ text: "Dispatch statistics", value: "Dispatch statistics" },
	{ text: "Reports", value: "Reports" },

	{ divider: true, value: "Accounting" },
	{ header: "Accounting", value: "Accounting" },
	{ text: "Schedules", value: "Schedules" },
	{ text: "Scheduled payments", value: "Scheduled payments" },
	{ text: "Fuel", value: "Fuel" },
	{ text: "Driver statements", value: "Driver statements" },
	{ text: "Safety statements", value: "Safety statements" },
	{ text: "Manager statements", value: "Manager statements" },
	{ text: "Short payments", value: "Short payments" },
	{ text: "Bonus/charge for employee", value: "Bonus/charge for employee" },
	{ text: "Company expenses", value: "Company expenses" },
	{ text: "Billing", value: "Billing" },
	{ text: "Customer invoices", value: "Customer invoices" },
	{ text: "Customer invoice items", value: "Customer invoice items" },
	{ text: "Customer payments", value: "Customer payments" },
	{ text: "Dispatchers statements", value: "Dispatchers statements" },

	{ divider: true, value: "Fleet" },
	{ header: "Fleet", value: "Fleet" },
	{ text: "Work orders", value: "Work orders" },
	{ text: "Work orders statistics", value: "Work orders statistics" },
	{ text: "Trucks on the road", value: "Trucks on the road" },

	{ divider: true, value: "Maintenance" },
	{ header: "Maintenance", value: "Maintenance" },
	{ text: "Potential client", value: "Potential client" },
	{ text: "Clients", value: "Clients" },
	{ text: "General", value: "General" },
	{ text: "Drivers", value: "Drivers" },
	{ text: "Trucks", value: "Trucks" },
	{ text: "Trailers", value: "Trailers" },
	{ text: "Customers", value: "Customers" },
	{ text: "Employees", value: "Employees" },
	{ text: "Cities", value: "Cities" },
	{ text: "Brokers", value: "Brokers" },
	{ text: "Factoring companies", value: "Factoring companies" },
	{ text: "Users", value: "Users" },
	{ text: "Roles", value: "Roles" },

	{ divider: true, value: "Settings" },
	{ header: "Settings", value: "Settings" },
	{ text: "User Account settings", value: "Account settings" },
	{ text: "Fleet Care settings", value: "Fleet Care settings" },
	{ text: "System settings", value: "System settings" },
	// { text: "Old system settings", value: "Old system settings", isPerm: true },
	{ text: "Other", value: "Other", isPerm: true }

];
